// Frontend API URL
export const BASE_URL = 'https://api.leadwithtech.in/api';

// Frontend API endpoints
export const API_ENDPOINTS = {
    BASE_URL: `${BASE_URL}`,
    NEWSLETTER_SUBSCRIBE: `${BASE_URL}/newsletter/subscribe`,
    LEADS_SUBMIT: `${BASE_URL}/leads`,
    LEADS_ADMIN_ALL: `${BASE_URL}/leads/admin/all`,
    NEWSLETTER_ADMIN_ALL: `${BASE_URL}/newsletter/admin/all`,
    LEADS_ADMIN_SEND_EMAIL: `${BASE_URL}/leads/admin/sendemail`,
    // Add other endpoints here
};